import { ApiClientFactory } from "@/utils/api-client/factories/clients";
import { CertificateManager } from "@/utils/api-client/CertificateManager";

export class CertificateManagerFactory {
  private readonly apiClientFactory: ApiClientFactory;

  constructor(baseUrl: string) {
    this.apiClientFactory = new ApiClientFactory(
      `${baseUrl}/api/v1/certificate`
    );
  }

  createCertificateManager(authToken: string): CertificateManager {
    return new CertificateManager(
      this.apiClientFactory.createAuthorizedApiClient(authToken)
    );
  }
}
